const BASE_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:8000'

async function handleError(res: Response): Promise<void> {
  if (res.ok) return
  let detail: string | undefined
  try { detail = (await res.json())?.detail } catch { /* ignore */ }
  throw new Error(detail ?? `Request failed (${res.status})`)
}

export async function updateCustomerSettings(
  apiKey: string,
  updates: {
    business_name?: string
    config?: Record<string, unknown>
  },
): Promise<void> {
  const res = await fetch(`${BASE_URL}/api/customers/me`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', 'X-API-Key': apiKey },
    body: JSON.stringify(updates),
  })
  await handleError(res)
}

export async function updateLocationSettings(
  apiKey: string,
  locationId: string,
  updates: {
    brand_voice?: string
    notification_email?: string
    config?: Record<string, unknown>
    brief_enabled?: boolean
    brief_day_of_week?: number
    brief_hour?: number
    brief_timezone?: string
  },
): Promise<void> {
  const res = await fetch(`${BASE_URL}/api/locations/${encodeURIComponent(locationId)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', 'X-API-Key': apiKey },
    body: JSON.stringify(updates),
  })
  await handleError(res)
}

export async function createLocation(
  apiKey: string,
  data: { name: string; address?: string },
): Promise<{ id: string; name: string }> {
  const res = await fetch(`${BASE_URL}/api/locations/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-API-Key': apiKey },
    body: JSON.stringify({ name: data.name, address: data.address || undefined }),
  })
  if (!res.ok) {
    let detail: string | undefined
    try { detail = (await res.json())?.detail } catch { /* ignore */ }
    throw new Error(detail ?? `Request failed (${res.status})`)
  }
  return res.json()
}
